module.exports = __webpack_public_path__ + "static/media/envelope-solid.82189696.svg";